import { useQuery } from '@apollo/client';
import ErrorPage from '@website/components/utilities/ErrorPage';
import LoadingPage from '@website/components/utilities/LoadingPage';
import {
  GetUsersHostDocument,
  GetUsersHostQuery,
} from '@website/types/graphqlOperations';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { Button, Container } from 'react-bootstrap';

interface ListHostsForAUserHostsItemsProps {
  hosts: GetUsersHostQuery['user']['hostRoles']['items'];
}

function ListHostsForAUserHostsItems({
  hosts,
}: ListHostsForAUserHostsItemsProps) {
  return (
    <div className="d-grid gap-2">
      {hosts.map((host) => (
        <Link
          href={`/hosts/dashboard/${host.host.urlSlug}`}
          key={host.host.id}
          passHref
          legacyBehavior
        >
          <Button as="a" role="button" variant="primary" size="lg">
            {host.host.name}
          </Button>
        </Link>
      ))}
    </div>
  );
}

interface ListHostsForAUserProps {
  userID: string;
}

/**
 *
 * List all hosts that a user has permission to manage
 *
 */
export default function ListHostsForAUser({ userID }: ListHostsForAUserProps) {
  const { push } = useRouter();

  const { loading, error, data } = useQuery(GetUsersHostDocument, {
    fetchPolicy: 'cache-and-network',
    variables: {
      userID,
    },
    onCompleted: ({ user }) => {
      if (user.hostRoles.items.length === 1) {
        push(`/hosts/dashboard/${user.hostRoles.items[0].host.urlSlug}`);
      }
    },
  });

  if ((loading && !data) || data.user.hostRoles.items.length === 1) {
    return <LoadingPage />;
  }

  if (error && !data) {
    return <ErrorPage error={error} />;
  }

  return (
    <Container className="pt-3">
      <h1>My Hosts</h1>
      {data && (
        <ListHostsForAUserHostsItems hosts={data.user.hostRoles.items} />
      )}
    </Container>
  );
}
